import { Expose } from 'class-transformer'
import { Quote } from '../../entity'

export class ListAllQuotesDTO {

    @Expose()
    quotes!: Quote[]

}
